import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { keys, map, filter} from 'lodash'
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortable } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormControl, FormGroup } from '@angular/forms';
import * as Moment from 'moment'


@Component({
  selector: 'app-org-activity',
  templateUrl: './org-activity.component.html',
  styleUrls: ['./org-activity.component.scss']
})
export class OrgActivityComponent implements OnInit, OnDestroy {
  @Input() superAdmin: boolean
  @ViewChild(MatSort) sort: MatSort;
  endDate;
  startDate;
  days = 7
  data = {}
  orgs
  displayedColumns = ['name', 'entityId', 'active','newUsers', "instructor", "student"]
  leaving = new Subject()
  range : FormGroup
  mode = "indeterminate"
  displayStart;
  displayEnd;
  loading = false
  constructor(
    private aff: AngularFireFunctions
  ) {
    this.range = new FormGroup({
      start: new FormControl(new Date()),
      end: new FormControl(new Date())
    });
   }

  ngOnInit(){
    this.endDate = Moment().startOf('day')
    this.startDate = Moment().subtract(this.days, 'days').startOf('day')
    this.displayEnd = this.endDate.format('YYYY-MM-DD')
    this.displayStart = this.startDate.format('YYYY-MM-DD')

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sort.sort(({id: 'active', start: 'desc'}) as MatSortable)
      this.setup()
    }, 0)
  }

  ngOnDestroy(): void {
    this.leaving.next()
  }

  setStartDate = (date) => {
    const lastStartDate = this.startDate
    const d = Moment(date).startOf('day')
    if (d.isAfter(this.endDate)) {
      alert("Start date must be before end date")
      this.startDate = lastStartDate
      return 
    } else {
      this.startDate = d
      
      this.updateDay()
    }
    this.displayStart = this.startDate.format("YYYY-MM-DD")
  }

  setEndDate = (date) => {   
    const lastEndDate = this.endDate
    const d = Moment(date).startOf('day')
    if ( d.isBefore(this.startDate)) {

      this.endDate = lastEndDate
      return 
    } else if(d.isAfter(Moment())) {

      this.endDate = lastEndDate
      return
    }else {
      this.endDate = d
      this.displayEnd = this.endDate.format("YYYY-MM-DD")
      this.updateDay()
    }
    this.displayEnd = this.endDate.format("YYYY-MM-DD")
  }

  updateDay = () => {
    // console.log(this.endDate, this.startDate)
    this.days = Math.ceil(Moment.duration(this.endDate.valueOf() - this.startDate.valueOf()).asDays())
  }

  setup = async () => {
    try{
      if(!this.superAdmin){
        return
      }
      this.loading = true
      const start = this.startDate.valueOf()
      const end = this.endDate.valueOf()
      const callable = this.aff.httpsCallable('activityStats')
      const result = await callable({startDate: start, endDate: end})
        .take(1)
        .toPromise()
      this.process(result)
      
    } catch(e) {
      console.error(e)
    } finally {
      this.loading = false
    }

  }


  process = (data) => {
    // console.log(data)
    const orgs =  filter(map(keys(data), key => data[key]), item => !!item.name)
    this.orgs = orgs
    // console.log(orgs)
    this.orgs = new MatTableDataSource<any[]>(orgs)
    this.orgs.sort = this.sort
    this.loading = false
  }



}
